/**
 * 单一渲染
 */
export class SimpleRenderer {
}
